module.exports = __webpack_public_path__ + "static/img/ID0_DownBG.2ec3393.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sprite/ID0_DownBG.png
// module id = p/04
// module chunks = 0